<div id="error-page-container">
    <div id="text-container">
        <h1 class="title">{{ 'serverErrorPage.title' | translate }}</h1>

        <div class="content">
            <p>{{ 'serverErrorPage.content.firstSentence' | translate }}</p>
            <p>
                <i>{{ 'serverErrorPage.content.secondSentence' | translate }}</i>
            </p>
            <p>
                <span [innerHtml]="'serverErrorPage.content.thirdSentence' | translate"></span
                ><span class="link">888-321-2113</span>.
            </p>
        </div>

        <div class="action-buttons">
            <button
                id="go-to-dashboard-btn"
                pButton
                type="button"
                class="p-button p-button-lg"
                aria-label="Live Chat Button"
                [label]="'serverErrorPage.backToDashboard.button.text' | translate"
                (click)="goToDashboard()"></button>
            <button
                id="live-chat-btn"
                pButton
                type="button"
                icon="far fa-comments"
                class="p-button-outlined p-button-lg"
                aria-label="Live Chat Button"
                [label]="'serverErrorPage.liveChat.button.text' | translate"
                (click)="openChat()"></button>
        </div>
    </div>

    <div id="image-container">
        <img
            width="800"
            height="447"
            [ngSrc]="'assets/images/illustrations/error_500.svg'"
            [alt]="'img.alt.serverError' | translate" />
    </div>
</div>
